export default __webpack_public_path__ + "static/media/fauna-docs-drivers.043313c9.png";